import { render, staticRenderFns } from "./loanClosure.vue?vue&type=template&id=f1c82c12&scoped=true&lang=html"
import script from "./loanClosure.vue?vue&type=script&lang=js"
export * from "./loanClosure.vue?vue&type=script&lang=js"
import style0 from "./loanClosure.vue?vue&type=style&index=0&id=f1c82c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c82c12",
  null
  
)

export default component.exports